const initialState = {
  fetching: false,
  fetched: false,
  saving: false,
  saved: false,
  data: [],
  error: null,
  presentationConfig: {
    date: null,
    target: null,
    isPrepared: 0,
    isPresented: 0,
    isFrozen: 0,
    presenters: [],
    thankingSlide: 1,
    questionsSlide: 1,
    conclusion: { enabled: 0, content: "" },
    extraSlides: { enabled: 0, slides: [], showFrame: false },
    hiddenSlides: []
  },
  currentSlideIndex: 0,
  users: {
    fetching: false,
    fetched: false,
    items: [],
    error: null
  }
};

export const presentationReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INIT_PRESENTATION": {
      return { ...initialState };
    }
    case "FETCH_PRESENTATION_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }
    case "FETCH_PRESENTATION_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        data: action.payload,
        presentationConfig: action.payload.id
          ? action.payload
          : state.presentationConfig
      };
    }
    case "FETCH_PRESENTATION_REJECTED": {
      let error = action.payload;
      if (!error.response) {
        error = {
          title: error,
          code: 500
        };
      } else {
        switch (error.response.status) {
          case 404:
            error = {
              title: error.response.data.title,
              code: 404
            };
            break;
          default:
        }
      }
      return {
        ...state,
        fetching: false,
        data: [],
        error
      };
    }
    case "SET_PRESENTATION_DATE": {
      return {
        ...state,
        presentationConfig: {
          ...state.presentationConfig,
          date: action.date
        }
      };
    }
    case "SET_PRESENTATION_TARGET": {
      return {
        ...state,
        presentationConfig: {
          ...state.presentationConfig,
          target: action.target
        }
      };
    }
    case "SET_PRESENTATION_IS_PREPARED": {
      return {
        ...state,
        presentationConfig: {
          ...state.presentationConfig,
          isPrepared: action.isPrepared
        }
      };
    }
    case "SET_PRESENTATION_IS_PRESENTED": {
      return {
        ...state,
        presentationConfig: {
          ...state.presentationConfig,
          isPresented: action.isPresented
        }
      };
    }
    case "SET_PRESENTATION_THANKING_SLIDE": {
      return {
        ...state,
        presentationConfig: {
          ...state.presentationConfig,
          thankingSlide: action.thankingSlide
        }
      };
    }
    case "SET_PRESENTATION_QUESTIONS_SLIDE": {
      return {
        ...state,
        presentationConfig: {
          ...state.presentationConfig,
          questionsSlide: action.questionsSlide
        }
      };
    }
    case "SET_PRESENTATION_EXTRA_SLIDES": {
      return {
        ...state,
        presentationConfig: {
          ...state.presentationConfig,
          extraSlides: {
            ...state.presentationConfig.extraSlides,
            enabled: action.extraSlides
          }
        }
      };
    }

    case "SET_SHOW_FRAME_EXTRA_SLIDES": {
      return {
        ...state,
        presentationConfig: {
          ...state.presentationConfig,
          extraSlides: {
            ...state.presentationConfig.extraSlides,
            showFrame: action.showFrame
          }
        }
      };
    }

    case "SET_PRESENTATION_EXTRA_SLIDES_CONTENT": {
      return {
        ...state,
        presentationConfig: {
          ...state.presentationConfig,
          extraSlides: {
            ...state.presentationConfig.extraSlides,
            slides: action.content
          }
        }
      };
    }

    // @todo Delete Conclusion
    case "SET_PRESENTATION_CONCLUSION": {
      return {
        ...state,
        presentationConfig: {
          ...state.presentationConfig,
          conclusion: {
            ...state.presentationConfig.conclusion,
            enabled: action.conclusion
          }
        }
      };
    }
    case "SET_PRESENTATION_CONCLUSION_CONTENT": {
      return {
        ...state,
        presentationConfig: {
          ...state.presentationConfig,
          conclusion: {
            ...state.presentationConfig.conclusion,
            content: action.content
          }
        }
      };
    }

    case "SET_PRESENTATION_HIDDEN_SLIDES": {
      return {
        ...state,
        presentationConfig: {
          ...state.presentationConfig,
          hiddenSlides: action.hiddenSlides
        }
      };
    }

    case "SET_PRESENTATION_CURRENT_SLIDE_INDEX": {
      return {
        ...state,
        currentSlideIndex: action.currentSlideIndex
      };
    }

    case "SET_PRESENTATION_PRESENTERS": {
      return {
        ...state,
        presentationConfig: {
          ...state.presentationConfig,
          presenters: action.presenters
        }
      };
    }

    case "FETCH_PRESENTATION_USERS_PENDING": {
      return {
        ...state,
        users: { ...state.users, fetched: false, fetching: true }
      };
    }
    case "FETCH_PRESENTATION_USERS_FULFILLED": {
      return {
        ...state,
        users: {
          fetching: false,
          fetched: true,
          items: action.payload.data.data,
          error: null
        }
      };
    }
    case "FETCH_PRESENTATION_USERS_REJECTED": {
      let error = action.payload;
      if (!error.response) {
        error = {
          title: error,
          code: 500
        };
      } else {
        switch (error.response.status) {
          case 404:
            error = {
              title: error.response.data.title,
              code: 404
            };
            break;
          default:
        }
      }
      return {
        ...state,
        users: {
          ...state.users,
          fetching: false,
          items: [],
          error
        }
      };
    }

    case `SAVE_PRESENTATION_PENDING`: {
      return { ...state, saved: false, saving: true };
    }
    case `SAVE_PRESENTATION_FULFILLED`: {
      return {
        ...state,
        saving: false,
        saved: true
      };
    }
    case `SAVE_PRESENTATION_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        saved: false,
        saving: false,
        error
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/presentation.js